import script from "./SourceList.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceList.vue?vue&type=script&setup=true&lang=js"

import "./SourceList.vue?vue&type=style&index=0&id=b1bc553e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1bc553e"]])

export default __exports__